export const HIGHLIGHTED_POST_QUERY_PARAM = 'highlight'
